import { getMonth, getYear } from "date-fns";
import DatePicker from "react-datepicker";
import { ChevronLeft, ChevronRight } from "react-feather";


/**
 * A function that returns a range of numbers from start to end
 * 
 * Start of the range
 * @param start 
 * 
 * End of range
 * @param end 
 * 
 * Range returns a list of numbers
 * @returns number[]
 */
const range = (start: number, end: number) => new Array(end - start + 1)
.fill(undefined).map((value, index) => index + start)

interface DefaultDatePickerProps {
    /**
     * Represents the name of the element
     */
    name: string;
    /**
     * Represents the selected record props
     */
    selected: Date | undefined;
    /**
     * onChange event the triggers on data change
     */
    onChange?: (data: Date, name: string) => void;
}

/**
 * Default datetime picker element
 * 
 * Represents the name of the element
 * @param name 
 * 
 * Represents the selected record props
 * @param selected 
 * 
 *  onChange event the triggers on data change
 * @param onChange 
 * @returns JSX.Element
 */
const DefaultDatePicker = ({name, selected, onChange}: DefaultDatePickerProps) => {
    const years = range(1990, getYear(new Date()) + 1);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return (
      <DatePicker className={"form-control"} style={{width: "100%"}}
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        } : any) => (
          <div
            style={{
              margin: 10,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button style={{border:0}} onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
              <ChevronLeft />
            </button>
            <select className="form-select" value={getYear(date)} onChange={({ target: { value } }) => changeYear(value)}>
              {years.map((option: number) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
  
            <select className="form-select" value={months[getMonth(date)]} onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}>
              {months.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
  
            <button style={{border:0}} onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
              <ChevronRight />
            </button>
          </div>
        )}
        selected={selected}
        onChange={(x: Date) => { onChange && onChange(x, name) }}
      />
    );
  };

  export default DefaultDatePicker;